import React from "react";
import { huespedesProps } from "./types/modal_tour";
import { useAppSelector } from "../../hooks/hooks"; // <-- Añadido para obtener el ID

interface Props {
    modalRefCalendar: React.RefObject<HTMLDivElement>;
    handleInputClick: ({ name, action }: huespedesProps) => void;
    huespedes: {
        adultos: number;
        ninos: number;
        mascotas: number;
    };
    handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ModalHuespedes = ({
    modalRefCalendar,
    handleInputClick,
    huespedes,
    handleInputChange,
}: Props) => {
    // --- LÓGICA DE COLORES DINÁMICOS ---
    const { id: casa_id } = useAppSelector(
        (state) => state.landing_house.house,
    );
    const isGlamping = casa_id === 378;
    const textAccentClass = isGlamping ? "text-[#4a4641]" : "text-[#1C4CBB]";
    const borderAccentClass = isGlamping
        ? "border-[#4a4641]"
        : "border-[#1C4CBB]";
    // -----------------------------------

    return (
        <div
            onClick={(e) => e.stopPropagation()}
            ref={modalRefCalendar}
            className="absolute top-16 right-0 w-full 2xl:p-5 p-3.5 border border-gray-400 shadow-lg bg-white rounded-lg z-50 transition-colors duration-300"
        >
            <div className="flex flex-col items-center justify-between">
                <div className="flex flex-col w-2/3 mx-auto gap-1 text-left">
                    <label
                        className={`text-sm ${textAccentClass} mb-2 font-bold transition-colors duration-300`}
                    >
                        Adultos
                    </label>
                    <div className="grid grid-cols-[20%_1fr_20%] w-full grid-flow-col gap-2">
                        <button
                            onClick={() =>
                                handleInputClick({
                                    action: "restar",
                                    name: "adultos",
                                })
                            }
                            className={`flex items-center justify-center w-full border ${borderAccentClass} rounded-lg hover:scale-105 transition-colors duration-300`}
                        >
                            <svg
                                className={`w-6 h-6 ${textAccentClass} transition-colors duration-300`}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <line x1="5" y1="12" x2="19" y2="12" />
                            </svg>
                        </button>

                        <input
                            className={`w-full p-2 font-medium text-center border ${borderAccentClass} rounded-lg transition-colors duration-300`}
                            type="number"
                            name="adultos"
                            value={huespedes.adultos}
                            onChange={handleInputChange}
                        />
                        <button
                            onClick={() =>
                                handleInputClick({
                                    action: "sumar",
                                    name: "adultos",
                                })
                            }
                            className={`flex items-center justify-center w-full border ${borderAccentClass} rounded-lg hover:scale-105 transition-colors duration-300`}
                        >
                            <svg
                                className={`w-6 h-6 ${textAccentClass} transition-colors duration-300`}
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" />
                                <line x1="12" y1="5" x2="12" y2="19" />
                                <line x1="5" y1="12" x2="19" y2="12" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div className="flex flex-col w-2/3 mx-auto gap-1 text-left mt-3">
                    <label
                        className={`text-sm ${textAccentClass} mb-2 font-bold transition-colors duration-300`}
                    >
                        Niños
                    </label>
                    <div className="grid grid-cols-[20%_1fr_20%] w-full grid-flow-col gap-2">
                        <button
                            onClick={() =>
                                handleInputClick({
                                    action: "restar",
                                    name: "ninos",
                                })
                            }
                            className={`flex items-center justify-center w-full border ${borderAccentClass} rounded-lg hover:scale-105 transition-colors duration-300`}
                        >
                            <svg
                                className={`w-6 h-6 ${textAccentClass} transition-colors duration-300`}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <line x1="5" y1="12" x2="19" y2="12" />
                            </svg>
                        </button>
                        <input
                            className={`w-full p-2 font-medium text-center border ${borderAccentClass} rounded-lg transition-colors duration-300`}
                            type="number"
                            name="ninos"
                            value={huespedes.ninos}
                            onChange={handleInputChange}
                        />
                        <button
                            onClick={() =>
                                handleInputClick({
                                    action: "sumar",
                                    name: "ninos",
                                })
                            }
                            className={`flex items-center justify-center w-full border ${borderAccentClass} rounded-lg hover:scale-105 transition-colors duration-300`}
                        >
                            <svg
                                className={`w-6 h-6 ${textAccentClass} transition-colors duration-300`}
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" />
                                <line x1="12" y1="5" x2="12" y2="19" />
                                <line x1="5" y1="12" x2="19" y2="12" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalHuespedes;
